var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _c("vop-provider-form", {
                    attrs: { mode: _vm.mode, readonly: !_vm.isEditable },
                    model: {
                      value: _vm.config,
                      callback: function ($$v) {
                        _vm.config = $$v
                      },
                      expression: "config",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.cncl"),
                  variant: "secondary",
                  "custom-class": "mr-3",
                },
                on: {
                  click: function ($event) {
                    return _vm.switchMode("details")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("administration.edit"),
                  icon: "fa-light fa-pencil",
                  variant: "primary",
                  "custom-class": "mr-3",
                },
                on: {
                  click: function ($event) {
                    return _vm.switchMode("edit")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("rights.delete"),
                  icon: "fa-light fa-trash",
                  variant: "danger",
                },
                on: { click: _vm.deleteVopProvider },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "primary",
                },
                on: { click: _vm.editVopProvider },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "primary",
                },
                on: { click: _vm.addVopProvider },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }